import { hasWarehouseAssignment } from '@gonfalon/experiments/hasWarehouseAssignment';
import { ExperimentStatusKind } from '@gonfalon/experiments/types';
import { msg } from '@gonfalon/messages/msg';

import { useExperimentIterationContext } from '#components/experimentation/common/providers/ExperimentIterationContextProvider';

export const analyzingDataMessage = () => msg('experiments.experimentResults.analyzingData');

/**
 * Results for experiments assigning from a warehouse source arrive on the warehouse's schedule, so an
 * empty result set means the data is still being processed rather than missing.
 */
export function useIsAnalyzingResultsData() {
  const { experiment, iteration } = useExperimentIterationContext();

  if (iteration?.status === ExperimentStatusKind.NOT_STARTED) {
    return false;
  }

  return hasWarehouseAssignment(experiment, iteration);
}

export function useResultsEmptyStateMessage(defaultMessage: string) {
  return useIsAnalyzingResultsData() ? analyzingDataMessage() : defaultMessage;
}
